import * as React from "react";
import { DecorateEditorialHtml } from "src/components/flexComponents/Editorial/ContentUtilities";
import { UitkText } from "uitk-react-text";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkLayoutGrid, UitkLayoutGridItem } from "uitk-react-layout-grid";
import { EditorialModel } from "src/typings/microserviceModels/content-flex-module";
import { UitkSpacing } from "uitk-react-spacing";

const CONTENT_ID_COUNT = 6;
export const CardComparisonBenefitsEditorial = (props: { items: EditorialModel[] }) => {
  const { items } = props;

  if (items.length !== CONTENT_ID_COUNT) {
    return null;
  }

  const [
    benefitsIconOne,
    benefitsContentOne,
    benefitsIconTwo,
    benefitsContentTwo,
    benefitsIconThree,
    benefitsContentThree,
  ] = React.useMemo(() => items.map((item) => <DecorateEditorialHtml key={item.id} text={item.text} />), []);

  return (
    <UitkSpacing
      padding={{ medium: { inline: "twelve" }, large: { inline: "unset", inlinestart: "twelve" } }}
      margin={{ medium: { inline: "twelve" }, large: { inline: "unset", inlinestart: "six" } }}
    >
      <div>
        <UitkLayoutGrid>
          <UitkSpacing padding={{ blockstart: "two" }}>
            <UitkLayoutGridItem>
              <UitkLayoutFlex space="three" alignItems="center">
                <UitkLayoutFlexItem>
                  <div>{benefitsIconOne}</div>
                </UitkLayoutFlexItem>
                <UitkLayoutFlexItem>
                  <div>
                    <UitkText size={400} weight="bold" align="left">
                      <div>{benefitsContentOne}</div>
                    </UitkText>
                  </div>
                </UitkLayoutFlexItem>
              </UitkLayoutFlex>
            </UitkLayoutGridItem>
          </UitkSpacing>
          <UitkSpacing padding={{ blockstart: "two" }}>
            <UitkLayoutGridItem>
              <UitkLayoutFlex space="three" alignItems="center">
                <UitkLayoutFlexItem>
                  <div>{benefitsIconTwo}</div>
                </UitkLayoutFlexItem>
                <UitkLayoutFlexItem>
                  <div>
                    <UitkText size={400} weight="bold" align="left">
                      <div>{benefitsContentTwo}</div>
                    </UitkText>
                  </div>
                </UitkLayoutFlexItem>
              </UitkLayoutFlex>
            </UitkLayoutGridItem>
          </UitkSpacing>
          <UitkSpacing padding={{ blockstart: "two" }}>
            <UitkLayoutGridItem>
              <UitkLayoutFlex space="three" alignItems="center">
                <UitkLayoutFlexItem>
                  <div>{benefitsIconThree}</div>
                </UitkLayoutFlexItem>
                <UitkLayoutFlexItem>
                  <div>
                    <UitkText size={400} weight="bold" align="left">
                      <div>{benefitsContentThree}</div>
                    </UitkText>
                  </div>
                </UitkLayoutFlexItem>
              </UitkLayoutFlex>
            </UitkLayoutGridItem>
          </UitkSpacing>
        </UitkLayoutGrid>
      </div>
    </UitkSpacing>
  );
};

export default CardComparisonBenefitsEditorial;
